// Libraries
import React from 'react'
import PropTypes from 'prop-types'

// PropTypes and DefaultProps
const defaultProps = {
  width: '136.577px',
  height: '133.02px',
  className: null,
}

const propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
}

// Component
function IconSuccess({ width, height, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 136.577 133.02"
    >
      <g transform="translate(-892.246 -386.079)">
        <path
          fill="#0070f2"
          opacity="0.148"
          d="M73.791,0c29.076,0,31.5,6.641,31.5,34.835S77.927,77.707,52.646,85.884,0,63.029,0,34.835,44.715,0,73.791,0Z"
          transform="matrix(0.799, 0.602, -0.602, 0.799, 944.733, 386.079)"
        />
        <g transform="translate(941.806 394.57)">
          <g transform="translate(0 0)">
            <path
              fill="#0f7eff"
              d="M42.046,263.023A21.023,21.023,0,1,1,21.023,242,21,21,0,0,1,42.046,263.023Zm0,0"
              transform="translate(0 -204.314)"
            />
            <path
              fill="#0056bf"
              d="M156.023,263.023A21,21,0,0,1,135,284.046V242A21,21,0,0,1,156.023,263.023Zm0,0"
              transform="translate(-113.977 -204.314)"
            />
            <path
              fill="#fff"
              d="M96.786,339.77l-8.643,8.69L85.807,350.8,79.5,344.442l3.27-3.27,3.037,2.99,2.336-2.336,5.373-5.326Zm0,0"
              transform="translate(-67.12 -284.098)"
            />
            <path
              fill="#fff"
              d="M143.643,339.77,135,348.46v-6.634l5.373-5.326Zm0,0"
              transform="translate(-113.977 -284.098)"
            />
            <path
              fill="#388ff4"
              d="M180.995,147.213l-6.587,6.587a10.952,10.952,0,0,1-8.035,3.083c-5.28,0-11.54-2.8-16.725-8.035-8.362-8.316-10.512-19.2-4.952-24.761l6.587-6.587Zm0,0"
              transform="translate(-119.56 -99.202)"
            />
            <path
              fill="#2a7ddd"
              d="M224.547,227.755l-6.587,6.587a10.952,10.952,0,0,1-8.035,3.083c-5.279,0-11.54-2.8-16.725-8.035L209.69,212.9Zm0,0"
              transform="translate(-163.113 -179.744)"
            />
            <path
              fill="#559ff5"
              d="M216.815,130.58a10.965,10.965,0,0,1-7.989,3.037,16.568,16.568,0,0,1-3.877-.467,29.33,29.33,0,0,1-20.416-20.415c-1.168-4.859-.234-9.11,2.57-11.867,4.391-4.438,12.427-4.018,19.949.981l8.783,8.783C220.833,118.153,221.254,126.188,216.815,130.58Zm0,0"
              transform="translate(-155.381 -82.57)"
            />
            <path
              fill="#3c8eef"
              d="M260.261,176.34a10.965,10.965,0,0,1-7.989,3.037,16.566,16.566,0,0,1-3.877-.467,27.469,27.469,0,0,1-12.894-7.522L254.888,152l4.391,4.391C264.278,163.913,264.7,171.948,260.261,176.34Zm0,0"
              transform="translate(-198.826 -128.329)"
            />
            <path
              fill="#80baff"
              d="M314.895,14.746,288.935,35.77a6.7,6.7,0,0,1-6.634-6.634L303.309,3.16a8.253,8.253,0,1,1,11.586,11.586Zm0,0"
              transform="translate(-238.339 0)"
            />
            <path
              fill="#6cabf7"
              d="M325.534,27.826,299.574,48.85a6.46,6.46,0,0,1-4.672-1.962l31.379-31.4A8.233,8.233,0,0,1,325.534,27.826Zm0,0"
              transform="translate(-248.978 -13.08)"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

IconSuccess.defaultProps = defaultProps
IconSuccess.propTypes = propTypes

export default IconSuccess
